import { useState } from 'react';
import { EyeHiddenIcon_24, EyeVisibleIcon_24 } from 'assets/icons';

type Props = {
  changeSecuredState: VoidFunction;
};

export const SecureIcon = ({ changeSecuredState }: Props): JSX.Element => {
  const [isSecured, setIsSecured] = useState(true);

  const onClick = () => {
    setIsSecured((prevValue) => !prevValue);
    changeSecuredState();
  };

  if (isSecured)
    return (
      <i onClick={onClick}>
        <EyeHiddenIcon_24 />
      </i>
    );

  return (
    <i onClick={onClick}>
      <EyeVisibleIcon_24 />
    </i>
  );
};

export default SecureIcon;
